import React from 'react';
import PropTypes from 'prop-types';
import Title from '../base/Title/Title';
import ComplaintPositionTable from './ComplaintPositionTable';
import ComplaintPositionEmailsTable from '../ComplaintPositionEmails/ComplaintPositionEmailsTable';
import WaybillData from '../WaybillData/WaybillDataPreview';
import textTranslates from './translate.json';


const ComplaintPositionOverview = ({complaintPosition, componentsToRender, onEditWaybillDataButtonClick, complaintType, canEditWaybill}) => {
    
    function getFormTitle(complaintType) {
        switch (complaintType.name) {
            case "DeliveryMismatch":
                return textTranslates.title.deliveryMismatch;
            case "PayedRepair":
                return textTranslates.title.payedRepair;
            case "PostWarrantyLaserDeviceCalibration":
                return textTranslates.title.postWarrantyLaserDeviceCalibration;
            case "SalesWarranty":
                return textTranslates.title.salesWarranty;
            case "TransportDamage":
                return textTranslates.title.transportDamage;
            case "UnderWarrantyLaserDeviceCalibration":
                return textTranslates.title.underWarrantyLaserDeviceCalibration;
            case "Warranty":
                return textTranslates.title.warranty;
        }
        return "";
    }

    function handleEditWaybillDataButtonClick() {
        onEditWaybillDataButtonClick(complaintPosition.id, complaintPosition.waybillNumber, complaintPosition.waybillCourier);
    }
    const title = getFormTitle(complaintType);
    return(
        <div
            key={complaintPosition.id}
            id={`complaintPreviewPosition${complaintPosition.id}`}>
            <Title
                id={`complaintPreviewPosition${complaintPosition.id}Title`}
                title={title}/>
            <ComplaintPositionTable
                componentsToRender={componentsToRender}
                position={complaintPosition} />
            {/* <WaybillData
                waybillCourier={complaintPosition.waybillCourier}
                waybillNumber={complaintPosition.waybillNumber}
                onEditWaybillDataButtonClick={handleEditWaybillDataButtonClick}
                showEditButton={canEditWaybill} /> */}
            {complaintPosition.emails && complaintPosition.emails.length > 0 &&
                <ComplaintPositionEmailsTable emails={complaintPosition.emails} />}
           
        </div>
    );
};

ComplaintPositionOverview.propTypes = {
    complaintPosition: PropTypes.object,
    componentsToRender: PropTypes.array,
    onEditWaybillDataButtonClick: PropTypes.func,
    complaintType: PropTypes.object,
    canEditWaybill: PropTypes.bool
};

export default ComplaintPositionOverview;


// WEBPACK FOOTER //
// ./src/components/ComplaintPostionOverview/ComplaintPositionOverview.js